import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { ImageUpload } from "@/components/ImageUpload";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, CircleNotch } from "@phosphor-icons/react";
import { toast } from "sonner";

async function uploadLogo(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/marketing/upload?kind=logo", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data.id;
}

function ColorField({ label, value, onChange, testid }) {
  return (
    <div className="space-y-1.5"><Label>{label}</Label>
      <div className="flex items-center gap-2">
        <input type="color" value={value} onChange={(e) => onChange(e.target.value.toUpperCase())} className="h-10 w-14 cursor-pointer rounded-md border border-input bg-transparent" data-testid={`${testid}-picker`} />
        <Input value={value} onChange={(e) => onChange(e.target.value)} className="font-mono" maxLength={7} data-testid={testid} />
      </div>
    </div>
  );
}

export default function MarketingBrand() {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/marketing/brand").then((r) => setF(r.data)).catch((e) => toast.error(apiError(e))); }, []);
  if (!f) return <div className="flex h-60 items-center justify-center"><CircleNotch size={26} className="animate-spin text-primary" /></div>;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async () => {
    setBusy(true);
    try { setF(await api.put("/marketing/brand", f).then((r) => r.data)); toast.success("Ficha de marca guardada"); }
    catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };

  return (
    <div className="space-y-6" data-testid="marketing-brand-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <Button variant="outline" size="icon" className="rounded-full" asChild><Link to="/marketing"><ArrowLeft size={18} /></Link></Button>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">Marketing</p>
            <h1 className="font-display text-3xl font-extrabold tracking-tight">Ficha de marca</h1>
          </div>
        </div>
        <Button className="rounded-full" onClick={save} disabled={busy} data-testid="mk-brand-save">{busy ? <CircleNotch className="animate-spin" /> : "Guardar"}</Button>
      </div>
      <p className="text-sm text-muted-foreground">Estes dados aparecem por cima das fotos em todos os posts e stories. Enquanto estiverem vazios, as imagens mostram “[a definir]”.</p>
      <section className="grid gap-5 rounded-xl border border-border bg-card p-5 md:grid-cols-[220px_1fr]">
        <div className="space-y-1.5"><Label>Logótipo (PNG com fundo transparente, de preferência)</Label>
          <ImageUpload value={f.logo_id} onChange={(v) => setF({ ...f, logo_id: v })} testid="mk-brand-logo" uploader={uploadLogo} label="Carregar logo" /></div>
        <div className="grid content-start gap-4 sm:grid-cols-2">
          <div className="space-y-1.5 sm:col-span-2"><Label>Nome da marca</Label><Input value={f.company_name} onChange={set("company_name")} data-testid="mk-brand-name" /></div>
          <ColorField label="Cor principal (fundo)" value={f.primary_color} onChange={(v) => setF({ ...f, primary_color: v })} testid="mk-brand-primary" />
          <ColorField label="Cor de destaque" value={f.accent_color} onChange={(v) => setF({ ...f, accent_color: v })} testid="mk-brand-accent" />
          <div className="space-y-1.5"><Label>Telefone</Label><Input value={f.phone} onChange={set("phone")} placeholder="+41 ..." data-testid="mk-brand-phone" /></div>
          <div className="space-y-1.5"><Label>Site</Label><Input value={f.website} onChange={set("website")} placeholder="www.exemplo.ch" data-testid="mk-brand-website" /></div>
        </div>
      </section>
    </div>
  );
}
